import PropTypes from "prop-types";

// use setActiveTabsId to pass get the selectedTabsId
const TabPanel = ({ className, children, title }) => {
  return (
    <div title={title} className={className}>
      {children}
    </div>
  );
};

TabPanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default TabPanel;
